module.exports = __webpack_public_path__ + "jacques-7a4ac8bf4267c67041de2a3b7ab927b6.webp";